module.exports = __webpack_public_path__ + "static/media/familia.06f923d8.png";